var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideocamOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 6.73684 4.73684 6 6 6H14C15.2632 6 16 6.73684 16 8V16C16 17.2632 15.2632 18 14 18H6C4.73684 18 4 17.2632 4 16V8ZM2 8V16C2 18.2456 3.75439 20 6 20H14C16.2456 20 18 18.2456 18 16V8C18 5.75438 16.2456 4 14 4H6C3.75439 4 2 5.75438 2 8ZM21.0877 9.19298C20.6667 9.54386 20 9.21052 20 8.66667V15.3333C20 14.7895 20.6667 14.4561 21.0877 14.807L18 12.4912V11.5088L21.0877 9.19298ZM19.8596 7.61403L16 10.4912V13.5088L19.8596 16.386C20.7193 17.0702 22 16.4561 22 15.3333V8.66667C22 7.54386 20.7193 6.92982 19.8596 7.61403Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocamOutlined);
export default __webpack_public_path__ + "static/media/videocam_outlined.55ea1d5f.svg";
export { ForwardRef as ReactComponent };